module.exports = __webpack_public_path__ + "static/banner-tv-strass-base-reta-8cf26f51dadccf4f529ca949c7c655c8.jpg";